(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lb-all-collection"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('lb-all-collection')){
customElements.define('lb-all-collection',class extends HTMLElement{
connectedCallback(){
if(this.bound)return;this.bound=true;this.setupContinuousScroll();
this.addEventListener('click',event=>{
const button=event.target.closest('[data-shop-filter]');if(!button)return;
const filter=button.dataset.shopFilter;
this.querySelectorAll('[data-shop-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
let visible=0;
this.querySelectorAll('.lb-shop-card').forEach(card=>{const show=filter==='all'||card.dataset.shopCategory===filter||(filter==='gifts'&&card.dataset.littleGift==='true');card.hidden=!show;if(show)visible++;});
this.querySelector('[data-filter-count]').textContent=visible+' '+(filter==='all'?'products':button.textContent.toLowerCase()+' products');
});
this.addEventListener('change',event=>{
const select=event.target.closest('select[name="id"],input[type="radio"][name="id"]');if(!select)return;
const form=select.closest('form'),card=select.closest('article'),option=select.tagName==='SELECT'?select.selectedOptions[0]:select;
card.querySelector('[data-price]').textContent=option.dataset.price||'';
const addButton=form.querySelector('button[type="submit"]');
addButton.disabled=!select.value||option.disabled;
if(!addButton.disabled)addButton.textContent=addButton.dataset.ready;
form.querySelector('[role="status"]').textContent='';form.querySelector('.lb-shop-cart').hidden=true;
});
this.addEventListener('submit',async event=>{
const form=event.target.closest('.lb-shop-form');if(!form)return;event.preventDefault();event.stopImmediatePropagation();
const button=form.querySelector('button[type="submit"]'),status=form.querySelector('[role="status"]'),variant=form.elements.id.value;
if(!variant||button.disabled)return;if(!form.checkValidity()){form.reportValidity();return;}button.disabled=true;button.textContent=this.dataset.adding||'Adding…';status.textContent=button.textContent;form.setAttribute('aria-busy','true');
try{
const root=window.Shopify?.routes?.root||'/';
const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(variant),quantity:1,...(form.dataset.preorderNote?{properties:{'Preorder acknowledged':'Yes','Preorder shipping':form.dataset.preorderNote}}:{})}]})});
const result=await response.json();if(!response.ok)throw new Error(result.description||'Unable to add this item. Please try again.');
status.textContent='Added to your cart.';form.querySelector('.lb-shop-cart').hidden=false;
const cartResponse=await fetch(root+'cart.js').catch(()=>null);if(cartResponse?.ok){const cart=await cartResponse.json();document.querySelectorAll('[cart-counter],[data-cart-count],.cart-count').forEach(el=>{el.textContent=cart.item_count;});}
document.dispatchEvent(new CustomEvent('cart:updated',{detail:{items:result.items}}));
if(window.Rebuy?.SmartCart?.refresh)window.Rebuy.SmartCart.refresh();
}catch(error){status.textContent=error.message;}
finally{form.removeAttribute('aria-busy');button.disabled=false;button.textContent=button.dataset.ready;}
},true);
}

setupContinuousScroll(){
this.more=this.querySelector('[data-merch-more]');this.grid=this.querySelector('.lb-shop-grid');
if(!this.more||!this.grid||!this.more.dataset.nextUrl||!window.fetch)return;
this.more.hidden=false;const pagination=this.querySelector('[data-merch-pagination]');if(pagination)pagination.hidden=true;
this.loadButton=this.more.querySelector('[data-merch-load-more]');this.loadStatus=this.more.querySelector('[data-merch-load-status]');this.readyLabel=this.loadButton.textContent;this.autoLoad=true;
this.addEventListener('keydown',event=>{if(event.key==='Tab')this.autoLoad=false;});
this.loadButton.addEventListener('click',()=>this.loadNextProducts(true));
this.scrollHandler=()=>{if(this.autoLoad&&this.more.getBoundingClientRect().top<=window.innerHeight+350)this.loadNextProducts(false);};window.addEventListener('scroll',this.scrollHandler,{passive:true});
if('IntersectionObserver' in window){this.observer=new IntersectionObserver(entries=>{if(entries.some(entry=>entry.isIntersecting)&&this.autoLoad)this.loadNextProducts(false);},{rootMargin:'350px 0px'});this.observer.observe(this.more);}
}
async loadNextProducts(manual){
if(this.loading||!this.more.dataset.nextUrl)return;
this.loading=true;this.loadButton.disabled=true;this.loadButton.textContent=this.dataset.loadingLabel;this.grid.setAttribute('aria-busy','true');this.loadStatus.textContent=this.dataset.loadingLabel;this.requestAbort=new AbortController();
try{
const url=new URL(this.more.dataset.nextUrl,location.origin);if(url.origin!==location.origin)throw new Error('Invalid collection URL');
url.searchParams.set('section_id',this.dataset.sectionId);
const response=await fetch(url,{headers:{Accept:'text/html'},signal:this.requestAbort.signal});if(!response.ok)throw new Error('Unable to load products');
const html=new DOMParser().parseFromString(await response.text(),'text/html'),nextRoot=html.querySelector('lb-all-collection'),cards=nextRoot?.querySelectorAll('.lb-shop-grid > .lb-shop-card');
if(!cards?.length)throw new Error('No products returned');
const fragment=document.createDocumentFragment();cards.forEach(card=>fragment.appendChild(document.importNode(card,true)));const firstNew=fragment.firstElementChild;this.grid.appendChild(fragment);
this.more.dataset.nextUrl=nextRoot.querySelector('[data-merch-more]')?.dataset.nextUrl||'';
const loaded=this.grid.querySelectorAll('.lb-shop-card').length;
this.loadStatus.textContent=this.more.dataset.nextUrl?loaded+' / '+this.dataset.totalProducts+' '+this.dataset.loadedLabel:this.dataset.completeLabel;
if(manual)firstNew.querySelector('a')?.focus();
if(!this.more.dataset.nextUrl){this.observer?.disconnect();this.loadButton.hidden=true;}
}catch(error){if(error.name!=='AbortError'){this.autoLoad=false;this.loadStatus.textContent=this.dataset.loadError;}}
finally{this.loading=false;this.grid.removeAttribute('aria-busy');this.loadButton.disabled=false;this.loadButton.textContent=this.readyLabel;if(this.more.dataset.nextUrl&&this.autoLoad)requestAnimationFrame(this.scrollHandler);}
}
disconnectedCallback(){this.observer?.disconnect();this.requestAbort?.abort();window.removeEventListener('scroll',this.scrollHandler);}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lb-archive-shop"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('lb-archive-shop')){
customElements.define('lb-archive-shop',class extends HTMLElement{
connectedCallback(){
if(this.bound)return;this.bound=true;
this.addEventListener('click',event=>{
const button=event.target.closest('[data-size-filter]');if(!button)return;const size=button.dataset.sizeFilter;
this.querySelectorAll('[data-size-filter]').forEach(el=>el.setAttribute('aria-pressed',String(el===button)));
this.querySelectorAll('[data-available-sizes]').forEach(card=>{
card.hidden=size!=='all'&&!card.dataset.availableSizes.split('|').includes(size);
if(!card.hidden&&size!=='all'){const select=card.querySelector('select[name="id"]');if(select){const option=[...select.options].find(option=>option.dataset.size===size&&!option.disabled);if(option){select.value=option.value;select.dispatchEvent(new Event('change',{bubbles:true}));}}}
});
this.querySelector('.lb-archive-empty').hidden=!!this.querySelector('[data-available-sizes]:not([hidden])');
});
this.addEventListener('change',event=>{
const select=event.target.closest('select[name="id"]');if(!select)return;
const form=select.closest('form'),card=select.closest('article'),option=select.selectedOptions[0];
card.querySelector('[data-price]').textContent=option.dataset.price||'';card.querySelector('[data-compare]').textContent=option.dataset.compare||'';
form.querySelector('button[type="submit"]').disabled=!select.value||option.disabled;
form.querySelector('[role="status"]').textContent='';form.querySelector('.lb-shop-cart').hidden=true;
});
this.addEventListener('submit',async event=>{
const form=event.target.closest('.lb-shop-form');if(!form)return;event.preventDefault();event.stopImmediatePropagation();
const button=form.querySelector('button[type="submit"]'),status=form.querySelector('[role="status"]'),variant=form.elements.id.value;
if(!variant||button.disabled)return;button.disabled=true;button.textContent=this.dataset.adding||'Adding…';status.textContent=button.textContent;form.setAttribute('aria-busy','true');
try{
const root=window.Shopify?.routes?.root||'/';
const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(variant),quantity:1}]})});
const result=await response.json();if(!response.ok)throw new Error(result.description||'Unable to add this item. Please try again.');
status.textContent='Added to your cart.';form.querySelector('.lb-shop-cart').hidden=false;
const cartResponse=await fetch(root+'cart.js').catch(()=>null);if(cartResponse?.ok){const cart=await cartResponse.json();document.querySelectorAll('[cart-counter],[data-cart-count],.cart-count').forEach(el=>{el.textContent=cart.item_count;});}
document.dispatchEvent(new CustomEvent('cart:updated',{detail:{items:result.items}}));
if(window.Rebuy?.SmartCart?.refresh)window.Rebuy.SmartCart.refresh();
}catch(error){status.textContent=error.message;}
finally{form.removeAttribute('aria-busy');button.disabled=false;button.textContent=button.dataset.ready;}
},true);
}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lb-delivered-shop"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('lb-delivered-shop')){
customElements.define('lb-delivered-shop',class extends HTMLElement{
connectedCallback(){
if(this.bound)return;this.bound=true;
this.addEventListener('click',event=>{
const button=event.target.closest('[data-filter]');if(!button)return;
this.querySelectorAll('[data-filter]').forEach(el=>el.setAttribute('aria-pressed',String(el===button)));
const key=button.dataset.filter;this.querySelectorAll('[data-category]').forEach(card=>card.hidden=key!=='all'&&card.dataset.category!==key);
const available=[...this.querySelectorAll('.lb-shop-grid:first-of-type [data-category]')];
const grids=[...this.querySelectorAll('.lb-shop-grid')];const first=grids[0];
this.querySelector('.lb-del-empty').hidden=!!first?.querySelector('[data-category]:not([hidden])');
const unavailable=this.querySelector('.lb-del-unavailable');if(unavailable)unavailable.hidden=!unavailable.querySelector('[data-category]:not([hidden])');
});
this.addEventListener('change',event=>{
const select=event.target.closest('select[name="id"],input[type="radio"][name="id"]');if(!select)return;
const form=select.closest('form'),card=select.closest('article'),option=select.tagName==='SELECT'?select.selectedOptions[0]:select;
card.querySelector('[data-price]').textContent=option.dataset.price||'';
form.querySelector('button[type="submit"]').disabled=!select.value||option.disabled;
form.querySelector('[role="status"]').textContent='';form.querySelector('.lb-shop-cart').hidden=true;
});
this.addEventListener('submit',async event=>{
const form=event.target.closest('.lb-shop-form');if(!form)return;event.preventDefault();event.stopImmediatePropagation();
const button=form.querySelector('button[type="submit"]'),status=form.querySelector('[role="status"]'),variant=form.elements.id.value;
if(!variant||button.disabled)return;if(!form.checkValidity()){form.reportValidity();return;}button.disabled=true;button.textContent=this.dataset.adding||'Adding…';status.textContent=button.textContent;form.setAttribute('aria-busy','true');
try{
const root=window.Shopify?.routes?.root||'/';
const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(variant),quantity:1,...(form.dataset.preorderNote?{properties:{'Preorder acknowledged':'Yes','Preorder shipping':form.dataset.preorderNote}}:{})}]})});
const result=await response.json();if(!response.ok)throw new Error(result.description||'Unable to add this item. Please try again.');
status.textContent='Added to your cart.';form.querySelector('.lb-shop-cart').hidden=false;
const cartResponse=await fetch(root+'cart.js').catch(()=>null);if(cartResponse?.ok){const cart=await cartResponse.json();document.querySelectorAll('[cart-counter],[data-cart-count],.cart-count').forEach(el=>{el.textContent=cart.item_count;});}
document.dispatchEvent(new CustomEvent('cart:updated',{detail:{items:result.items}}));
if(window.Rebuy?.SmartCart?.refresh)window.Rebuy.SmartCart.refresh();
}catch(error){status.textContent=error.message;}
finally{form.removeAttribute('aria-busy');button.disabled=false;button.textContent=button.dataset.ready;}
},true);
}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lb-drink-recommendations"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('lb-rounds-quick')){
customElements.define('lb-rounds-quick',class extends HTMLElement{
connectedCallback(){if(this.bound)return;this.bound=true;this.addEventListener('change',event=>{const radio=event.target.closest('input[type="radio"][name="id"]');if(!radio)return;const price=radio.closest('form').querySelector('[data-pack-price]');if(price)price.textContent=radio.dataset.price;});this.addEventListener('click',event=>{const button=event.target.closest('[data-rounds-direction]');if(!button)return;const track=button.parentElement.previousElementSibling;track.scrollBy({left:Number(button.dataset.roundsDirection)*(track.clientWidth*.88+12),behavior:'smooth'});});this.addEventListener('submit',async event=>{
const form=event.target.closest('.lb-rounds-form');if(!form)return;event.preventDefault();event.stopPropagation();
const button=form.querySelector('button');if(button.disabled)return;
const status=form.querySelector('[role="status"]');button.disabled=true;button.textContent=button.dataset.adding;status.textContent='';
try{const response=await fetch(window.Shopify.routes.root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(form.elements.id.value),quantity:1}]})});const result=await response.json();if(!response.ok)throw new Error(result.description||'Unable to add this item. Please try again.');
status.textContent=button.dataset.added;form.querySelector('.lb-rounds-cart-link').hidden=false;
document.dispatchEvent(new CustomEvent('cart:updated',{detail:{items:result.items}}));
if(window.Rebuy&&window.Rebuy.SmartCart&&typeof window.Rebuy.SmartCart.refresh==='function')window.Rebuy.SmartCart.refresh();
}catch(error){status.textContent=error.message;}finally{button.disabled=false;button.textContent=button.dataset.ready;}
});}
});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lb-merch-collection"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('lb-merch-collection')){
customElements.define('lb-merch-collection',class extends HTMLElement{
connectedCallback(){
if(this.bound)return;this.bound=true;this.setupContinuousScroll();
this.addEventListener('change',event=>{
const select=event.target.closest('select[name="id"],input[type="radio"][name="id"]');if(!select)return;
const form=select.closest('form'),card=select.closest('article'),option=select.tagName==='SELECT'?select.selectedOptions[0]:select;
card.querySelector('[data-price]').textContent=option.dataset.price||'';
const addButton=form.querySelector('button[type="submit"]');
addButton.disabled=!select.value||option.disabled;
if(!addButton.disabled)addButton.textContent=addButton.dataset.ready;
form.querySelector('[role="status"]').textContent='';form.querySelector('.lb-shop-cart').hidden=true;
});
this.addEventListener('submit',async event=>{
const form=event.target.closest('.lb-shop-form');if(!form)return;event.preventDefault();event.stopImmediatePropagation();
const button=form.querySelector('button[type="submit"]'),status=form.querySelector('[role="status"]'),variant=form.elements.id.value;
if(!variant||button.disabled)return;if(!form.checkValidity()){form.reportValidity();return;}button.disabled=true;button.textContent=this.dataset.adding||'Adding…';status.textContent=button.textContent;form.setAttribute('aria-busy','true');
try{
const root=window.Shopify?.routes?.root||'/';
const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(variant),quantity:1,...(form.dataset.preorderNote?{properties:{'Preorder acknowledged':'Yes','Preorder shipping':form.dataset.preorderNote}}:{})}]})});
const result=await response.json();if(!response.ok)throw new Error(result.description||'Unable to add this item. Please try again.');
status.textContent='Added to your cart.';form.querySelector('.lb-shop-cart').hidden=false;
const cartResponse=await fetch(root+'cart.js').catch(()=>null);if(cartResponse?.ok){const cart=await cartResponse.json();document.querySelectorAll('[cart-counter],[data-cart-count],.cart-count').forEach(el=>{el.textContent=cart.item_count;});}
document.dispatchEvent(new CustomEvent('cart:updated',{detail:{items:result.items}}));
if(window.Rebuy?.SmartCart?.refresh)window.Rebuy.SmartCart.refresh();
}catch(error){status.textContent=error.message;}
finally{form.removeAttribute('aria-busy');button.disabled=false;button.textContent=button.dataset.ready;}
},true);
}

setupContinuousScroll(){
this.more=this.querySelector('[data-merch-more]');this.grid=this.querySelector('.lb-shop-grid');
if(!this.more||!this.grid||!this.more.dataset.nextUrl||!window.fetch)return;
this.more.hidden=false;const pagination=this.querySelector('[data-merch-pagination]');if(pagination)pagination.hidden=true;
this.loadButton=this.more.querySelector('[data-merch-load-more]');this.loadStatus=this.more.querySelector('[data-merch-load-status]');this.readyLabel=this.loadButton.textContent;this.autoLoad=true;
this.addEventListener('keydown',event=>{if(event.key==='Tab')this.autoLoad=false;});
this.loadButton.addEventListener('click',()=>this.loadNextProducts(true));
this.scrollHandler=()=>{if(this.autoLoad&&this.more.getBoundingClientRect().top<=window.innerHeight+350)this.loadNextProducts(false);};window.addEventListener('scroll',this.scrollHandler,{passive:true});
if('IntersectionObserver' in window){this.observer=new IntersectionObserver(entries=>{if(entries.some(entry=>entry.isIntersecting)&&this.autoLoad)this.loadNextProducts(false);},{rootMargin:'350px 0px'});this.observer.observe(this.more);}
}
async loadNextProducts(manual){
if(this.loading||!this.more.dataset.nextUrl)return;
this.loading=true;this.loadButton.disabled=true;this.loadButton.textContent=this.dataset.loadingLabel;this.grid.setAttribute('aria-busy','true');this.loadStatus.textContent=this.dataset.loadingLabel;this.requestAbort=new AbortController();
try{
const url=new URL(this.more.dataset.nextUrl,location.origin);if(url.origin!==location.origin)throw new Error('Invalid collection URL');
url.searchParams.set('section_id',this.dataset.sectionId);
const response=await fetch(url,{headers:{Accept:'text/html'},signal:this.requestAbort.signal});if(!response.ok)throw new Error('Unable to load products');
const html=new DOMParser().parseFromString(await response.text(),'text/html'),nextRoot=html.querySelector('lb-merch-collection'),cards=nextRoot?.querySelectorAll('.lb-shop-grid > .lb-shop-card');
if(!cards?.length)throw new Error('No products returned');
const fragment=document.createDocumentFragment();cards.forEach(card=>fragment.appendChild(document.importNode(card,true)));const firstNew=fragment.firstElementChild;this.grid.appendChild(fragment);
this.more.dataset.nextUrl=nextRoot.querySelector('[data-merch-more]')?.dataset.nextUrl||'';
const loaded=this.grid.querySelectorAll('.lb-shop-card').length;
this.loadStatus.textContent=this.more.dataset.nextUrl?loaded+' / '+this.dataset.totalProducts+' '+this.dataset.loadedLabel:this.dataset.completeLabel;
if(manual)firstNew.querySelector('a')?.focus();
if(!this.more.dataset.nextUrl){this.observer?.disconnect();this.loadButton.hidden=true;}
}catch(error){if(error.name!=='AbortError'){this.autoLoad=false;this.loadStatus.textContent=this.dataset.loadError;}}
finally{this.loading=false;this.grid.removeAttribute('aria-busy');this.loadButton.disabled=false;this.loadButton.textContent=this.readyLabel;if(this.more.dataset.nextUrl&&this.autoLoad)requestAnimationFrame(this.scrollHandler);}
}
disconnectedCallback(){this.observer?.disconnect();this.requestAbort?.abort();window.removeEventListener('scroll',this.scrollHandler);}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lb-shop-products"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('lb-holiday-shop')){
customElements.define('lb-holiday-shop',class extends HTMLElement{
connectedCallback(){
if(this.bound)return;this.bound=true;
this.addEventListener('change',event=>{
const select=event.target.closest('select[name="id"],input[type="radio"][name="id"]');if(!select)return;
const form=select.closest('form'),card=select.closest('article'),option=select.tagName==='SELECT'?select.selectedOptions[0]:select;
card.querySelector('[data-price]').textContent=option.dataset.price||'';
const addButton=form.querySelector('button[type="submit"]');
addButton.disabled=!select.value||option.disabled;
if(!addButton.disabled)addButton.textContent=addButton.dataset.ready;
form.querySelector('[role="status"]').textContent='';form.querySelector('.lb-shop-cart').hidden=true;
});
this.addEventListener('submit',async event=>{
const form=event.target.closest('.lb-shop-form');if(!form)return;event.preventDefault();event.stopImmediatePropagation();
const button=form.querySelector('button[type="submit"]'),status=form.querySelector('[role="status"]'),variant=form.elements.id.value;
if(!variant||button.disabled)return;if(!form.checkValidity()){form.reportValidity();return;}button.disabled=true;button.textContent=this.dataset.adding||'Adding…';status.textContent=button.textContent;form.setAttribute('aria-busy','true');
try{
const root=window.Shopify?.routes?.root||'/';
const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(variant),quantity:1,...(form.dataset.preorderNote?{properties:{'Preorder acknowledged':'Yes','Preorder shipping':form.dataset.preorderNote}}:{})}]})});
const result=await response.json();if(!response.ok)throw new Error(result.description||'Unable to add this item. Please try again.');
status.textContent='Added to your cart.';form.querySelector('.lb-shop-cart').hidden=false;
const cartResponse=await fetch(root+'cart.js').catch(()=>null);if(cartResponse?.ok){const cart=await cartResponse.json();document.querySelectorAll('[cart-counter],[data-cart-count],.cart-count').forEach(el=>{el.textContent=cart.item_count;});}
document.dispatchEvent(new CustomEvent('cart:updated',{detail:{items:result.items}}));
if(window.Rebuy?.SmartCart?.refresh)window.Rebuy.SmartCart.refresh();
}catch(error){status.textContent=error.message;}
finally{form.removeAttribute('aria-busy');button.disabled=false;button.textContent=button.dataset.ready;}
},true);
}
});
}

  } catch(e) { console.error(e); }
})();
})();
